import { useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CastingFlow } from "./CastingFlow";

/**
 * Desktop modal shell for the casting application.
 * Mobile/touch visitors are routed to /apply instead (see Landing openApply).
 */
export const CastingModal = ({ open, onClose }) => {
  const attemptCloseRef = useRef(null);

  // Lock background scroll (incl. Lenis) while open
  useEffect(() => {
    if (!open) return;
    window.__lenis?.stop();
    document.body.style.overflow = "hidden";
    return () => {
      window.__lenis?.start();
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="casting-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[100] flex items-stretch md:items-center justify-center"
          role="dialog"
          aria-modal="true"
        >
          {/* Backdrop */}
          <div
            data-testid="casting-backdrop"
            onClick={() => attemptCloseRef.current?.()}
            className="absolute inset-0 bg-black/70 backdrop-blur-md"
          />

          {/* Panel */}
          <motion.div
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 16, scale: 0.98 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full h-screen supports-[height:100dvh]:h-[100dvh] md:h-auto md:max-h-[92vh] md:max-w-2xl md:rounded-2xl md:border md:border-white/10 bg-[#0a0a0a] flex flex-col overflow-hidden"
          >
            <CastingFlow
              variant="modal"
              onClose={onClose}
              onRegisterAttemptClose={(fn) => {
                attemptCloseRef.current = fn;
              }}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
